import {PANELMANAGER_SET_PANEL_PATH} from '../../constants';

export type SetPanelPathAction = {
    type : typeof PANELMANAGER_SET_PANEL_PATH;
    panelKey : string;
    path : string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {boolean} path
 *
 * @return {SetPanelPathAction}
 */
const setPanelPath = ( panelKey : string, path : string ) : SetPanelPathAction => {
    return {
        type: PANELMANAGER_SET_PANEL_PATH,
        panelKey,
        path
    };
}
export type SetPanelPath = typeof setPanelPath;

export default setPanelPath;
